import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useQueryParams = () => {
  const [params, setParams] = useSearchParams();

  return useMemo(
    () => ({
      get: (name: string) => params.get(name),
      set: (name: string, value: string) => {
        const newParams = new URLSearchParams(params);
        newParams.set(name, value);
        setParams(newParams);
      },
    }),
    [params, setParams]
  );
};
